<ng-template #modalSuccessExport let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="d()" text="{{ '' | translate }}">
    <div class="d-flex" body>
      <div class="align-self-center">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-success.svg'"></span>

      </div>
      <div>
        <span [innerHtml]="'export_success1' | translate"></span>
        <span class="font-weight-bold">{{ user.profile.email }} </span>
        <span>{{ 'export_success2' | translate }}</span>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalExportSmsList let-c="close" let-d="dismiss">
  <wsb-modal
    title="{{ 'common_export_messages' | translate }}"
    (dismiss)="d()"
    cancelButtonEnable="true"
    (primary)="export()"
    primaryButtonText="sms_detail_export_export"
    text="{{ 'common_export_text' | translate }}"
  >
    <div body>
      <p translate>common_export_text</p>
      <div>
        <div class="d-flex align-items-center">
          <div class="w-100">
            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'XLS'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_xls</span>
            </label>

            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'XLSX'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_xlsx</span>
            </label>

            <label class="radio-custom">
              <input type="radio" [formControl]="fc" [value]="'CSV'" />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>export_filetype_csv</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<div class="page">
  <div class="page__container">
    <div class="d-flex" style="align-items: center; justify-content: space-between;">
      <h1 class="page__title h2 mb-3">{{ 'reseller_history_title' | translate }}</h1>

      <div class="d-flex mb-3" style="width: 45%;">
        <span style="margin-right: 20px; align-self: center;" translate>reseller_senders_new_subaccount</span>
        <div class="w-100">
          <ng-select
            [items]="subaccounts"
            id="subaccount"
            [formControl]="subaccount"
            bindValue="idUser"
            bindLabel="login"
            [clearable]="false"
            (search)="onSearch($event)"
            class="form-control bulk-options-changer"
            (scrollToEnd)="onScrollToEnd()"
            (change)="onChange($event)"
          >
          </ng-select>
        </div>
      </div>
    </div>

    <!-- <div class="col-sm-8">
      <ng-select
        [items]="subaccounts"
        id="subaccount"
        [formControl]="subaccount"
        bindValue="idUser"
        bindLabel="login"
        [clearable]="false"
        (search)="onSearch($event)"
        class="form-control bulk-options-changer"
        (scrollToEnd)="onScrollToEnd()"
        (change)="onChange($event)"
      >
      </ng-select>
    </div> -->
    <div class="my-3 mb-5">
      <wsb-atlas-grid
        #grid
        class="atlas-grid-simplest"
        class="mt-5"
        *ngIf="tableColumnsDefs && tableHistoryGridOptions"
        [loading]="tableLoading"
        [columnDefs]="tableColumnsDefs"
        [checkboxDisable]="true"
        [options]="tableHistoryGridOptions"
        [exportFc]="fc"
        [showFilters]="true"
        [components]="components"
        [@gridIsLoaded]="gridAnimationState"
      ></wsb-atlas-grid>
    </div>
  </div>
</div>
